export default class DomainUrlBuilder {
    /**
     * DomainUrlBuilder constructor.
     */
    constructor() {
        this.currentUrl = window.document.URL;
        this.customDomain = ab.infinityCustomDomain;
        this.customDomainUrl = ab.infinityCustomDomainUrl;
    }

    /**
     * Build Url.
     *
     * @param  prefix string
     * @returns string
     */
    build(prefix = '') {
        if (this.customDomain == null) {
            return ab.baseUrl + prefix
        }

        if (this.currentUrl.indexOf(this.customDomain) == -1) {
            return ab.baseUrl + prefix
        }

        return this.customDomainUrl + prefix
    }

    /**
     * Constructs a URL string by appending the provided prefix to the origin of the current location.
     *
     * @param {string} [prefix=''] - The string to append to the origin. Defaults to an empty string if not provided.
     * @return {string} The resulting URL string combining the origin and the provided prefix.
     */
    buildFromOrigin(prefix = '/') {
        return window.location.origin + prefix
    }
}
